import actions from './actions'
// import { doFetch } from './common'

//////////
// AUTH //
//////////

//Reducer
export const authReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.login:
      return {
        ...action.data
      }
    default:
      return state
  }
}

//Actions
export const startLogin = (data) => {
  console.log('startLogin', data)
  return (dispatch) => {
    dispatch({type: actions.login, data})
  }
}

export const startLogout = () => {
  return (dispatch) => {
    localStorage.removeItem('user')
    dispatch({type: actions.logout})
    return true
  }
}



//////////
// FORM //
//////////

//Reducer
export const formReducer = (state = {}, action) => {
  switch (action.type) {
    case actions.setForm: 
      return {
        ...state,
        ...action.data
      }
    default:
      return state
  }
}

//Actions
export const setForm = (data) => {
  return (dispatch) => {
    dispatch({type: actions.setForm, data})
  }
}


